import React, { useState, useRef } from "react";
import { FiPhone, FiMail, FiArrowRight } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import QuoteModal from "../QuoteModal/index.tsx";
import "./index.css";

const PHONE = "+27 81 615 5344";
const EMAIL = "sales@yourbrand.co.za";

export function Contact() {
  const telHref = `tel:${PHONE.replace(/\s/g, "")}`;
  const mailHref = `mailto:${EMAIL}`;
  const waHref = `https://wa.me/${PHONE.replace(/\s/g, "").replace("+", "")}?text=Hi%20BioClockin%2C%20I’d%20like%20help%20choosing%20a%20device.`;

  const [quoteOpen, setQuoteOpen] = useState(false);
  const quoteBtnRef = useRef(null);

  const openModal = () => setQuoteOpen(true);
  const closeModal = () => {
    setQuoteOpen(false);
    setTimeout(() => quoteBtnRef.current?.focus(), 0);
  };

  return (
    <section id="contact" className="cta cta--enhanced ">
      <div className="container cta__wrap cta__wrap--enhanced">
        <div className="cta__copy">
          <span className="cta__eyebrow">Get started</span>
          <h2 className="cta__title">Start tracking attendance anywhere</h2>
          <p className="cta__text">
            Get an affordable, secure, <strong>offline-ready</strong>{" "}
            fingerprint system for your team.
          </p>
        </div>

        <div className="cta__actions cta__actions--stack">
          <a href={telHref} className="btn btn--cta">
            <FiPhone aria-hidden />
            <span>Call {PHONE}</span>
          </a>
          {/* <a
            href={waHref}
            className="btn btn--cta btn--whatsapp"
            target="_blank"
            rel="noreferrer"
          >
            <FaWhatsapp aria-hidden />
            <span>WhatsApp us</span>
          </a> */}
          <a href={mailHref} className="btn btn--cta btn--ghost">
            <FiMail aria-hidden />
            <span>Email us</span>
          </a>
          <a
            href="#contact"
            ref={quoteBtnRef}
            onClick={() => {
              openModal();
            }}
            className="btn btn--outline btn--cta-secondary"
          >
            <span>Request Demo</span>
            <FiArrowRight aria-hidden />
          </a>
        </div>
      </div>

      <QuoteModal open={quoteOpen} onClose={closeModal} />
    </section>
  );
}
